/**
 * 編輯媒體 caption Modal — 薄殼，內容由 EditMediaForm 提供。
 * MyPost / WorldCreate 使用；PostEditModal 不走 modal，直接 inline render Form。
 *
 * 儲存/取消按鈕統一放 Modal.Footer（全站 modal 慣例），
 * 透過 formRef 呼叫 EditMediaForm 暴露的 save()。
 */
import { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import EditMediaForm from './EditMediaForm';

const EditMediaModal = forwardRef(({ onSave }, ref) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [caption, setCaption] = useState('');
  const [currentMedia, setCurrentMedia] = useState(null);
  const [canSave, setCanSave] = useState(true);
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    show: (mediaItem, currentCaption = '') => {
      setCurrentMedia(mediaItem);
      setCaption(currentCaption);
      setShow(true);
    },
    hide: () => {
      setShow(false);
      setCurrentMedia(null);
      setCaption('');
    },
  }));

  const handleClose = () => {
    setShow(false);
    setCurrentMedia(null);
    setCaption('');
  };

  const handleSave = (index, value) => {
    onSave?.(index, value);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header className="border-0 pb-0" closeButton>
        <Modal.Title className="fw-bold">{t('edit')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-2">
        <EditMediaForm
          ref={formRef}
          media={currentMedia}
          initialCaption={caption}
          onSave={handleSave}
          onValidityChange={setCanSave}
        />
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-end gap-2">
        <button className="btn btn-neutral rounded-pill" onClick={handleClose}>
          {t('cancel')}
        </button>
        <button
          className="btn rounded-pill btn-primaryF"
          onClick={() => formRef.current?.save()}
          disabled={!canSave}
        >
          {t('save')}
        </button>
      </Modal.Footer>
    </Modal>
  );
});

EditMediaModal.displayName = 'EditMediaModal';

export default EditMediaModal;
